import React, { Component } from 'react';


class IteamAudioPlayerComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {paused: true};

        this.audioStop = this.audioStop.bind(this);

        this.audio = React.createRef();
    }

    componentDidMount() {
        this.props.setPagePauseAudioCallback(this.audioStop);
    }

    componentWillUnmount() {
        this.props.setPagePauseAudioCallback(null);
    }

    audioStop() {
        this.audio.current.pause();
        this.audio.current.currentTime = 0;
        this.setState({paused: true});
    }

    render() {
        return(<audio controls controlsList='nodownload' src={this.props.audiourl} ref={this.audio}></audio>);
    }
}

export default IteamAudioPlayerComponent;